export default __webpack_public_path__ + "static/media/fdep.da658fc3.png";